// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1NNRq","error":"Textarea_error__3Qctl","readonly":"Textarea_readonly__25rfk","disabled":"Textarea_disabled__W7foY"};